import storageService from '../services/storage';
import glp1TreatmentService from '../services/glp1-treatment';

/**
 * Function that executes in the pharmacy page.
 */
export default function pharmacy() {
  glp1Guard();
  handlePopup();
  noPersistCache();

  /**
   * Handles the pharmacy popup display.
   */
  function handlePopup() {
    if (storageService().tests.length > 0) {
      return;
    }

    document.querySelector('body').classList.add('shop-menu-pop-up-active');
  }

  /**
   * Glp1 guard.
   */
  function glp1Guard() {
    if (!glp1TreatmentService().isGlp1TreatmentType()) {
      return;
    }

    window.location.href = '/order';
  }

  /**
   * Ensures the page is reloaded if it's restored from the back-forward cache (bfcache).
   */
  function noPersistCache() {
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        window.location.reload();
      }
    });
  }
}
